import { BaseURL as B } from "../../config/axios";
import $ from 'jquery';
import { useCallback as uC, useEffect as uE, useState as uS } from "react";
import { getLandingPaintings as gLP } from "../../api-route/painting";
import 'justifiedGallery';
import { Link as L, useParams as uP } from "react-router-dom";

const d = (f, w) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => f.apply(this, a), w); }; };

export default function A({ initData: d0 = [], id: i = 0, title: t, url: u, withMore: m = true }) {
  const [d1, sD] = uS();
  const p = uP();

  uE(() => {
    if (d0.length) sD(d0)
    else {
      (async () => {
        const d2 = await gLP();
        sD(d2 || [])
      })()
    }
  }, [p])

  const g = uC(() => {
    const m = window.innerWidth < 768, rH = m ? 100 : 200, mar = m ? 5 : 10;
    $(`#mygallery${i}`).justifiedGallery('destroy').justifiedGallery({
      margins: mar, randomize: true, captions: true, rowHeight: rH,
      lastRow: (!!d1 && d1.length > 5) ? 'hide' : 'nojustify',
      cssAnimation: false
    });
  }, [d1]);

  uE(() => {
    if (!!d1 && d1.length) {
      g();
      const r = d(g, 100);
      window.addEventListener('resize', r);
      window.addEventListener('orientationchange', r);
      return () => {
        window.removeEventListener('resize', r);
        window.removeEventListener('orientationchange', r);
      };
    }
  }, [d1, g]);

  return (
    <>
      {!!d1 && d1.length &&
        <section className="container flex flex-col w-full items-center my-12 gap-6">
          <div dir="rtl" className="flex text-center flex-col gap-6">
            <h3 className="title">{t || "محبوب‌ترین آثار هنری"}</h3>
          </div>
          <div id={`mygallery${i}`} >
            {d1.map((itm, idx) => <GI key={idx} {...itm} />)}
          </div>
          {m && <L to={u ?? "/product?page=1"} className="bg-gray-200 rounded-lg px-4 py-2 text-md">
            نمایش همه آثار
          </L>}
        </section>
      }
    </>
  );
}

function GI({ id: i, slug: s, title: t, images: imgs }) {
  return (
    <L to={`/product/${s}`} className="group rounded relative block">
      <img
        src={B + imgs[0]?.path} title={t} width={100} height={100} className="w-full h-auto" alt={t} />
    </L>
  );
}
